// eslint-disable-next-line no-undef
const { __ } = wp.i18n

// eslint-disable-next-line no-undef
const object = vnObject

const place = (item, highlighter, classes = '') => {
  return `
    <article class="feed-place ${classes}">
        <a id="feed-place-url-${item.objectID}" href="${item.url}" title="${
    item.title
  }" class="feed-place__wrapper gtm_place_feed_visible gtm_place_feed_clicks">
            ${
              item.images.cards
                ? '<img class="feed-place__img" src="' +
                  item.images.cards +
                  '" alt="' +
                  item.title +
                  '">'
                : '<div class="feed-place__img"></div>'
            }
            <div class="feed-place__contents">
                <span class="feed-place__title"
                >${item.title}</span>
                <span class="feed-place__address"
                >
                ${item.zipCode ? item.zipCode : ''}${
    item.zipCode && item.city ? ', ' : ''
  }
                ${item.city ? item.city : ''}
                </span>
            </div>
        </a>
    </article>
  `
}

const placeHit = (item, classes = '') => {
  return `
    <article class="feed-place-hit type-${item.post_type.slug}${
    item.images.large ? ' has-post-thumbnail' : ''
  } ${classes}">
        <a id="feed-place-url-${item.objectID}" href="${item.url}" title="${
    item.title
  }" class="feed-place-hit__wrapper gtm_place_feed_visible gtm_place_feed_clicks" style="--bg: url(${
    item.images.large
  })">
            ${!item.images.large ? '<i class="vn-icons-big-wheel"></i>' : ''}
            <div class="feed-place-hit__contents">
                <span class="feed-place-hit__title"
                >${item._highlightResult.title.value}</span>
            </div>
            ${
              item._highlightResult.subtitle
                ? '<div class="feed-place-hit__long-title-container"><span class="feed-place-hit__long-title">' +
                  item._highlightResult.subtitle.value +
                  '</span></div>'
                : ''
            }
            <div class="feed-place-hit__terms">
                <span class="feed-place-hit__term">${item.post_type.name}</span>
                ${
                  item.diplomas.length
                    ? item.diplomas.map((diploma) => {
                        return `<span class="feed-place-hit__term">${diploma.name}</span>`
                      })
                    : ''
                }
                ${
                  item?.place_certifications_type?.length
                    ? item.place_certifications_type.map((certType) => {
                        return `<span class="feed-place-hit__term">${certType.name}</span>`
                      })
                    : ''
                }
            </div>
        </a>
    </article>
  `
}

const noResult = `<div class="feed-none g-col-6">${__(
  'There were no results!',
  'vn'
)}</div>`

const allPlaces = `<a href="${object.placesPage}" data-orig-href="${
  object.placesPage
}" class="all-places">
<span class="all-places__title">${__('See all', 'vn')}</span>
<span class="all-places__icon"><i class="vn-icons-arrow_circle_right"></i></span>
</a>`

export { place, noResult, allPlaces, placeHit }
